import React from 'react';
import T from 'prop-types';

import VerticalBar from './VerticalBar';
import PercentageChange from './PercentageChange';
import { formatAndAbbreviate, numberWithDelimiter } from '../utils/formatters';

const SubmissionsTable = ({ data }) => {
  const {
    months,
    stat_7d: stat7d,
    stat_max: statMax,
    stat_change: statChange,
    avg_per_day: avgPerDay,
  } = data;

  return (
    <div className="table-responsive">
      <table>
        <tbody>
          <tr className="v-a-t">
            <td className="p-t-0 p-l-0 p-b-0" style={{ paddingRight: 8 }}>
              <table className="app-summary-bars">
                <tbody>
                  <tr className="v-a-b">
                    {months.map(({ label, value }) => (
                      <td key={label} className="text-xxs-center">
                        <div>
                          <div className="text-xxxs">{formatAndAbbreviate(value, '', 3)}</div>
                        </div>
                        <VerticalBar value={value} base={statMax} maxHeight={40} color="blue" />
                        <div className="text-quiet text-xxxs">{label}</div>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </td>
            <td className="text-xxs-right p-a-0" width="160">
              <div className="text-xxl">{numberWithDelimiter(stat7d)}</div>
              <div className="text-sm">
                <PercentageChange value={statChange} />
              </div>
              <div className="text-xxxs text-quiet">Last Week</div>
            </td>
            <td className="text-xxs-right p-a-0" width="160">
              <div className="text-xxl" style={{ marginBottom: 27 }}>
                {numberWithDelimiter(avgPerDay)}
              </div>
              <div className="text-xxxs text-quiet">Avg. per Day</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export const submissionsShape = T.shape({
  months: T.arrayOf(
    T.shape({
      label: T.string,
      value: T.number,
    })
  ),
  stat_7d: T.number,
  stat_max: T.number,
  stat_change: T.number,
  avg_per_day: T.number,
});

SubmissionsTable.propTypes = {
  data: submissionsShape.isRequired,
};

export default SubmissionsTable;
